import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types/sharedSourcingStoreApi';
import { SourcingInviteSubmitPayload } from 'modules/sourcing-shared/shared-stores/types';
import { getEditedOpenMessageToUpdate } from '../getEditedOpenMessageToUpdate';
import { initializeSourcingSharedController } from '../initializeSourcingSharedController';
import { Channels } from 'generated-graphql/types';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';

export type HandleSourcingSharedCustomizeMessageInviteData = {
  payload: SourcingInviteSubmitPayload;
  customizeMessageFormData:
    | SourcingSharedCustomizeMessageEmailFormData
    | SourcingSharedCustomizeMessageSmsFormData;
};

type HandleSourcingSharedCustomizeMessageInviteSubmitControllerProps =
  HandleSourcingSharedCustomizeMessageInviteData & {
    get: SharedSourcingStoreApi['getState'];
    set: SharedSourcingStoreApi['setState'];
  };

export const handleSourcingSharedCustomizeMessageInviteSubmitController =
  async ({
    payload,
    customizeMessageFormData,
    get,
    set
  }: HandleSourcingSharedCustomizeMessageInviteSubmitControllerProps) => {
    const {
      candidateBatch,
      defaultStartingTemplatedMessage,
      editedOpeningMessage,
      jobInformationFormData,
      channelFormData,
      applicationFormData
    } = get();

    if (
      !candidateBatch?.id ||
      !jobInformationFormData ||
      !applicationFormData ||
      !defaultStartingTemplatedMessage
    ) {
      return;
    }

    const editedOpeningMessageToUpdate = getEditedOpenMessageToUpdate({
      campaignType: applicationFormData.campaignType,
      defaultStartingTemplatedMessage,
      editedOpeningMessage,
      customTemplatedMessage: customizeMessageFormData.customTemplatedMessage,
      channelType: channelFormData?.channel ?? Channels.Email
    });

    const updatedCustomizeMessageFormData = {
      ...customizeMessageFormData,
      customTemplatedMessage:
        editedOpeningMessageToUpdate ||
        customizeMessageFormData.customTemplatedMessage
    };

    await initializeSourcingSharedController({
      candidateBatch,
      payload,
      customizeMessageFormData: updatedCustomizeMessageFormData,
      jobInformationFormData,
      channelFormData: channelFormData ?? {
        channel: Channels.Email
      },
      applicationFormData
    });

    set({
      step: 'SUCCESS',
      customizeMessageFormData: updatedCustomizeMessageFormData,
      editedOpeningMessage: editedOpeningMessageToUpdate,
      candidateBatch: candidateBatch
        ? {
            ...candidateBatch,
            customJobPostingUrl: applicationFormData.customJobPostingUrl
          }
        : null
    });
  };
